import React from 'react';
import t from 'prop-types';

var Boton = function Boton(_ref) {
  var clases = _ref.clases,
      desactivado = _ref.desactivado,
      onClick = _ref.onClick,
      children = _ref.children;

  if (desactivado) {
    return React.createElement('div', {
      className: clases + ' desactivado'
    }, children);
  }

  return React.createElement('div', {
    className: '' + clases,
    onClick: onClick
  }, children);
};

Boton.propTypes = process.env.NODE_ENV !== "production" ? {
  clases: t.string,
  children: t.node,
  desactivado: t.bool,
  onClick: t.func
} : {};
Boton.defaultProps = {
  clases: '',
  desactivado: false
};
export default Boton;